/* eslint-disable @typescript-eslint/no-unused-vars */

import * as React from "react";
import * as _ from "lodash";
import {AbstractInputElement, FormElement} from "./FormInput";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from "moment";

export class FormDateTimeInput extends AbstractInputElement<number,FormElement<number,React.TextareaHTMLAttributes<any>>,{}> {

    getDefaultValue() : number {
        return Date.now();
    }
    dateChanged(value: moment.Moment | string) {
        if(typeof(value) != "string") {
            let time = value.toDate().getTime();
            this.onChange(time);
        }

    }

    render() {
        let selectedDateTime = new Date(this.getModelValue());
        let rest : React.TextareaHTMLAttributes<any> = _.omit(this.props,['validators',`model`, `fieldSet`, `modelValue`, `valid`, 'validationMap']);
        return <Datetime  value={selectedDateTime} onChange={(e) => this.dateChanged(e)}/>
   }

}

